import {
    AccountSyncTimes,
    AccountSyncTimesSource,
    getAccountSyncTimes,
    getDemoSyncedAt,
} from "@helpers/accountSyncTimes";
import { useIsDemoUser } from "./useIsDemoUser";

export function useFinancialAccountSyncTimes(
    account: AccountSyncTimesSource,
): AccountSyncTimes {
    const isDemoUser = useIsDemoUser();
    if (isDemoUser) {
        const demoSyncedAt = getDemoSyncedAt();
        return {
            transactionsSyncedAt: demoSyncedAt,
            balanceSyncedAt: demoSyncedAt,
            lastSyncedAt: demoSyncedAt,
        };
    }

    return getAccountSyncTimes(account);
}
